module.exports = __webpack_public_path__ + "img/icon-list1.917f3b8e.svg";